import type { Rol } from './types';

/**
 * De rol van de ingelogde gebruiker, buiten React om beschikbaar.
 *
 * De services zijn gewone functies zonder toegang tot React-context, maar
 * moeten wel weten uit welke bron ze mogen lezen. De AppProvider zet deze
 * waarde zodra iemand in- of uitlogt.
 *
 * Dit is puur voor het kiezen van de juiste bron. De echte afscherming zit in
 * de database: ook als hier iets misgaat, geeft Supabase een gemeentegebruiker
 * geen persoonsgegevens.
 */

let huidigeRol: Rol = 'gemeente';

export function zetHuidigeRol(rol: Rol | null): void {
  // Zonder gebruiker terugvallen op de minst bevoorrechte rol.
  huidigeRol = rol ?? 'gemeente';
}

export function getHuidigeRol(): Rol {
  return huidigeRol;
}
